import { FC } from 'react';
import { Button } from '@shared/ui/kit';
import { ArrowPathRectangleIcon } from '@shared/assets/icons';
import { fonts } from '@shared/tokens/fonts.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { StylesSettings } from '@shared/types/types';
import styles from './change-decision-trigger.module.scss';

interface ChangeDecisionTriggerProps {
  onClick: () => void;
}

// Цвет и фон фиксированы палитрой, а не токенами варианта: страница приглашения светлая
// независимо от темы, а accentText и primaryBackground в тёмной теме переворачиваются.
const TRIGGER_SETTINGS: StylesSettings = {
  height: 'auto',
  padding: '8px 16px',
  border: 'none',
  fontSize: '18px',
  lineHeight: '24px',
  fontFamily: fonts.din2014Regular,
  color: palette['bronze-500'],
  background: 'transparent',
};

export const ChangeDecisionTrigger: FC<ChangeDecisionTriggerProps> = ({ onClick }) => (
  <div className={styles.wrapper}>
    <Button variant="link" size="small" onClick={onClick} settings={TRIGGER_SETTINGS}>
      Изменить решение
      <ArrowPathRectangleIcon />
    </Button>
  </div>
);
